






































































import {Component, Model, Prop, Vue, Watch} from "vue-property-decorator";
import {VNode} from "vue/types/vnode";

@Component
export default class MultiSelect extends Vue {
    @Model('change') initialValue!: any[];
    @Prop({required: true}) id!: string;
    @Prop({required: true}) name!: string;
    @Prop({default: () => false}) hasErrors!: boolean;
    @Prop({default: () => true}) allowSelectAll!: boolean;
    @Prop({default: () => false}) asSingleSelect!: boolean;

    value: any[] = [];
    options: any[] = [];
    dropdownVisible: boolean = false;

    $slots!: { [key: string]: VNode[] | undefined } & { options: VNode[], button: VNode[] };

    get everythingSelected(): boolean {
        return this.value.length === this.options.length;
    }

    get nothingSelected(): boolean {
        return this.value.length === 0;
    }

    get btnText(): string {
        if (this.everythingSelected) {
            return 'Alles geselecteerd';
        }

        if (this.nothingSelected) {
            if (this.$slots.button != null) {
                return this.$slots.button[0].text!;
            }

            return 'Niks geselecteerd';
        }

        return this.value.reduce((str, value) => {
            const item = this.options.find((opt) => opt.value === value);

            if (item == null) {
                return str;
            }

            if (str.length > 0) {
                return str + ', ' + item.label;
            }

            return item.label;
        }, '');
    }

    @Watch('initialValue', {deep: true, immediate: true})
    onInitialValueChanged(value: any[] = []) {
        this.value = value;
    }

    close() {
        this.dropdownVisible = false;
    }

    mounted() {
        this.initOptions();
    }

    onCheckboxChanged(event: InputEvent) {
        const checkbox = event.target as HTMLInputElement;
        const value = checkbox.value;
        const checked = checkbox.checked;

        if (value === 'all') {
            if (checked) {
                this.value = this.options.map((option: any) => option.value);
            } else {
                this.value = [];
            }

            this.$emit('change', this.value);
            this.$forceUpdate();
            return;
        }

        if (this.value.includes(value) && checked === false) {
            this.value.splice(this.value.indexOf(value), 1);
        } else if (!this.value.includes(value) && checked === true) {
            this.value.push(value);
        }

        if (this.asSingleSelect && checked === true) {
            this.value = [value];
        }

        this.$emit('change', this.value);
        this.$forceUpdate();
    }

    private initOptions() {
        this.options = [];
        this.$slots.options.forEach((node: VNode) => {
            if (node.tag !== 'option') {
                return;
            }

            if (node.data!.attrs != null) {
                this.options.push({
                    label: node.children!.reduce((str, childNode: any) => str + ' ' + childNode.text, '').trim(),
                    value: node.data!.attrs!.value,
                });
            }

            this.options.push({
                label: node.children!.reduce((str, childNode: any) => str + ' ' + childNode.text, '').trim(),
                value: node.data!.domProps!.value,
            });
        });
    }
}
